import { createFileRoute } from '../../utils/route-factory';

const RouteComponent = () => {
  return <div>Global Settings Home</div>;
};

export const Route = createFileRoute({
  path: '/global-settings/',
  component: RouteComponent,
  type: 'auth',
});
